import Styled, { css } from 'styled-components';

import { media } from '../../lib/StyledComponents';

interface ICardGrid {
  oneColumn?: boolean;
  margin?: string;
}

export const CardGrid = Styled.div<ICardGrid>`
  /* IE11 Support */
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
  margin-top: ${({ margin }) => margin || '2.5em'};

  @supports (display: grid) {
    display: grid;
    grid-template-columns: 100%;
    grid-auto-rows: auto;
    grid-gap: 10px;

    ${({ oneColumn }) => css`
      ${media.small`
        grid-auto-rows: 1fr;
        grid-template-columns: ${oneColumn ? '100%' : 'repeat(2, 1fr)'};
        grid-gap: 16px;
      `}

      ${media.medium`
        grid-template-columns: ${oneColumn ? '100%' : 'repeat(3, 1fr)'};
      `}
    `}
  }
`;
